import { Routes, Route, Navigate } from "react-router-dom";
import { publicRoutes, posRoutes, pagesRoute, portalRoutes } from "./router.link";
import RequireAuth from "../services/RequireAuth.jsx";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
import { Outlet } from "react-router-dom";

export default function AllRoutes() {

  const PosLayout = () => (
    <RequireAuth>
      <Header />
      <Outlet />
    </RequireAuth>
  );

  const BackOfficeLayout = () => (
    <RequireAuth>
      <Header />
      <Sidebar />
      <Outlet />
    </RequireAuth>
  );

  return (
    <Routes>

      {/* PUBLIC ROUTES */}
      {publicRoutes.map((r) => (
        <Route key={r.id}
          path={r.path}
          element={r.element} />
      ))}

      {/* PORTAL ROUTE */}
      {portalRoutes.map((r) => (
        <Route key={r.id}
          path={r.path}
          element={
            <>{r.element}</>
          } />
      ))}

      {/* POS ROUTES */}
      <Route path="/pos" element={<PosLayout />}>
        {posRoutes.map((r) => (
          <Route key={r.id} index={r.path === ""} path={r.path} element={r.element} />
        ))}
      </Route>

      {/* BACK OF HOUSE */}
      <Route path="/back-of-house" element={<BackOfficeLayout />}>
        {pagesRoute.map((r) => (
          <Route key={r.id} index={r.path === ""} path={r.path} element={r.element} />
        ))}
      </Route>

      {/* DEFAULT REDIRECT */}
      <Route path="*" element={<Navigate to="/signin" replace />} />

    </Routes>
  );
}
